interface BestSellerBadgeProps {
  isVisible: boolean
  hasProductFlag?: boolean
  className?: string
}

export default function BestSellerBadge({
  isVisible,
  hasProductFlag = false,
  className,
}: Readonly<BestSellerBadgeProps>) {
  if (!isVisible || hasProductFlag) {
    return null
  }

  return (
    <div
      className={`hidden absolute left-4 top-2 z-[9] pointer-events-none ${
        className ?? ''
      }`}
      data-testid="best-seller-badge"
      data-dy-id="best-seller-badge"
    >
      <div
        className="
        relative flex flex-col items-center justify-center w-12 h-12
        md:w-[64px] md:h-[64px] bg-primaryBlue text-white
        font-black text-[11px] leading-tight tracking-wider text-center uppercase
        select-none shadow-md
        [clip-path:polygon(50%_0%,_57%_6%,_66%_3%,_71%_11%,_80%_11%,_82%_20%,_91%_23%,_90%_32%,_98%_38%,_94%_47%,_98%_56%,_90%_62%,_91%_71%,_82%_74%,_80%_83%,_71%_83%,_66%_91%,_57%_88%,_50%_94%,_43%_88%,_34%_91%,_29%_83%,_20%_83%,_18%_74%,_9%_71%,_10%_62%,_2%_56%,_6%_47%,_2%_38%,_10%_32%,_9%_23%,_18%_20%,_20%_11%,_29%_11%,_34%_3%,_43%_6%)]
      "
      >
        <span className="text-[6px] md:text-[8px] font-medium">MAIS</span>
        <span className="text-[6px] md:text-[8px] font-medium pb-0.5">
          VENDIDO
        </span>
      </div>
    </div>
  )
}
